import SideBySide from './SideBySide';

export default SideBySide;
